var _ellipse, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayRateNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 20.903,
    rx: 21,
    ry: 20.585,
    fill: "#E6F4F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.464 17.714c.227-.177.497-.306.786-.386v2.74a2.27 2.27 0 0 1-.786-.386c-.394-.307-.546-.668-.546-.984 0-.317.152-.677.546-.984zM21.75 24.493v-2.768c.347.083.664.223.921.412.427.314.579.673.579.972 0 .299-.152.658-.579.971-.257.19-.574.33-.921.413z",
    fill: "#17C2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 11.346c-5.385 0-9.75 4.28-9.75 9.557 0 5.279 4.365 9.558 9.75 9.558s9.75-4.28 9.75-9.558-4.365-9.557-9.75-9.557zm.75 3.676a.743.743 0 0 0-.75-.735c-.414 0-.75.329-.75.735v.8a3.874 3.874 0 0 0-1.72.74c-.712.555-1.113 1.324-1.113 2.136s.401 1.58 1.114 2.135a3.872 3.872 0 0 0 1.719.741v2.918a2.558 2.558 0 0 1-.921-.412l-.879-.646a.76.76 0 0 0-1.05.147.726.726 0 0 0 .15 1.03l.879.645a4.168 4.168 0 0 0 1.821.735v.794c0 .406.336.735.75.735s.75-.33.75-.735v-.794a4.17 4.17 0 0 0 1.821-.735c.745-.547 1.179-1.317 1.179-2.147 0-.83-.434-1.6-1.179-2.148a4.169 4.169 0 0 0-1.821-.734v-2.899c.29.08.559.21.786.386l.415.323a.76.76 0 0 0 1.054-.118.725.725 0 0 0-.121-1.033l-.415-.323a3.874 3.874 0 0 0-1.719-.741v-.8z",
    fill: "#17C2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayRateNewIcon);
export default __webpack_public_path__ + "static/media/payRate-new-icon.a3513e5b288b54944ab4c308c14bf785.svg";
export { ForwardRef as ReactComponent };